/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'
//import objectFitImages from 'object-fit-images';

import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import tabs from './tabs.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //polyfill for IE object-fit on images - https://github.com/fregante/object-fit-images
    //var $objectFit = $('img.object-fit');
    //objectFitImages($objectFit);

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    $('nav.subnav').responsiveNav({
        navType: 'dropdown',
        closeOnOutsideClick: false,
        showTabsOnFocus: false,
        menuButtonSelector: '.subnav__mobile-toggle',
        dropdownSelector: '.subnav__menu'
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion('accordion', 'a');

    //donation template tabs
    // if( document.querySelector('.tabs') ){
    //     tabs();
    // }


    const petSort = document.getElementById('petSort');
    if (petSort) {
        petSort.addEventListener('change', (event) => {
            petSort.closest('form').submit();
        });
    }

    const blogFilter = document.getElementById('blogFilter');
    if (blogFilter) {
        blogFilter.addEventListener('change', (event) => {
            var catLink = event.target.value;
            window.location.href = catLink;
        });
    }

    if ($('.alert-bar')) {
        var alertbar = $('.alert-bar');
        var closealertbar = $('.close-alertbar');

        $(closealertbar).on('click', function (e) {
            e.preventDefault();
            //close the alertbar
            alertbar.slideUp();
            // persist the dismissal in a cookie
            document.cookie = closealertbar.data('alert-cookie');
        });

    }

    if ($('.alert-popup').length > 0) {
        console.log('alert popup should show');
        $.magnificPopup.open({
            items: {
                src: '#alert-popup',
                type: 'inline',
            },
            alignTop: true,
            modal: true,
            mainClass: 'mfp-fade'
        });
        $(document).on('click', '.close-alertpopup', function (e) {
            var closealertpopup = $(this);
            e.preventDefault();
            $.magnificPopup.close();

            // persist the dismissal in a cookie
            document.cookie = closealertpopup.data('alert-cookie');
        });
        $(document).on('click', '.alertpopup-cta', function(e) {
            var closealertpopup = $('.close-alertpopup');
            e.preventDefault();

            // persist the dismissal in a cookie
            document.cookie = closealertpopup.data('alert-cookie');

            if ($(this).attr('target') == '_blank') {
                window.open($(this).attr('href'),"_blank");
                window.focus();
            } else {
                window.location.href=$(this).attr('href');
            }
        });
    }


    //OPEN SEARCH POPUP
    $('.open-search').magnificPopup({
        type:'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade mfp-fullscreen',
        focus: '#s',
    });

    // close button on search popup
    $(document).on('click', '.close-search', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // esc key search popup close.
    $(document).on('keyup',function(e) {
        if (e.key === 'Escape' || e.key === 'Esc' || e.key === 27) {
            e.preventDefault();
            $.magnificPopup.close();
        }
    });


})(jQuery)
